import store from '../../../store';

export const setAllInFalse = async () => {
    await store.dispatch("setDrawerLinkAction", false);
    await store.dispatch("setDrawerFilesAction", false);
    await store.dispatch("setDrawerUploadAction", false);
    await store.dispatch("setDrawerActivityAction", false);
    await store.dispatch("setDrawerNewProductAction", false);
    await store.dispatch("setDrawerUpdateDocumentAction", false);
};